import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { ClientSelectionService } from '../components/clients/client-selection.service';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { GetRREsResponse, RRE } from '../models/rre-management.model';

@Injectable({
    providedIn: 'root',
})
export class RreManagementService {
    private readonly endpoint = 'rre-management/rres';

    constructor(
        private http: HttpClient,
        private clientSelectionService: ClientSelectionService
    ) {}

    getRREs(sortBy?: string, sortDir?: 'asc' | 'desc', searchTerm?: string, skip = 0, count = 20): Observable<GetRREsResponse> {
        let params = new HttpParams()
            .set('skip', skip.toString())
            .set('count', count.toString())
            .set('sortBy', sortBy ?? '')
            .set('sortDir', sortDir ?? '');

        const trimmedSearchTerm = String(searchTerm ?? '').trim();
        if (trimmedSearchTerm) {
            params = params.set('search', trimmedSearchTerm);
        }
        
        const url = `${environment.apiUrl}${this.endpoint}`;
        return this.http.get<GetRREsResponse>(url, { headers: this.getHeaders(), params });
    }

    addRRE(rre: RRE): Observable<{ success: boolean }> {
        const url = `${environment.apiUrl}${this.endpoint}`;
        return this.http.post<{ success: boolean }>(url, rre, { headers: this.getHeaders() });
    }

    updateRRE(rre: RRE): Observable<{ success: boolean }> {
        const url = `${environment.apiUrl}${this.endpoint}`;
        return this.http.put<{ success: boolean }>(url, rre, { headers: this.getHeaders() });
    }

    private getHeaders() {
        const clientDBName = this.clientSelectionService.getSelectedClientDbName();
        return new HttpHeaders({
            ClientDBName: clientDBName,
        });
    }
}